<template>
  <component :is="tag" :class="{ open: isOpen }">
    <slot name="trigger" v-bind="{ isOpen, toggle }" />
    <slot name="collapsible" v-bind="{ isOpen, toggle, close }" />
  </component>
</template>
<script>
export default {
  props: {
    tag: {
      type: String,
      default: 'div'
    }
  },

  data () {
    return {
      isOpen: false
    }
  },

  watch: {
    isOpen (newValue) {
      this.$emit(newValue ? 'opened' : 'closed')
    }
  },

  methods: {
    toggle () {
      this.isOpen = !this.isOpen
    },

    close () {
      this.isOpen = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Collapsible.vue